import { AppMarketPermissions, AppMode } from '../models/enums';
import { useMemo } from 'react';
import { usePermissionContext } from '../contexts/providers/permissions';
import { useAppMode } from './useAppMode';

// use permission will always return enabled = true in Public App mode
export const usePermission = (permissionType: AppMarketPermissions): { enabled: boolean, isLoading: boolean } => {
  const appMode = useAppMode();
  const { isLoading: permissionsLoading, data } = usePermissionContext();
  const enabled = useMemo((): boolean => {
      if (appMode === AppMode.Public) return true;
      if (!permissionsLoading && data?.ids.length) {
        const { entities } = data;
        return !!entities[permissionType];
      }
      return false;
    }, [data, permissionType, permissionsLoading, appMode],
  );
  return {
    enabled,
    isLoading: permissionsLoading,
  };
};
